import * as Cookies from 'js-cookie'
const state = {
	// 单位名称
	unitName: '',
	// 单位id
	unitId: '',
	// 单位网段
	unitCode: '',
	// 单位id
	company_id: '',
	// 电脑端
	mobile: 0,
	// 登录刷新
	refresh: 1,
	// 考试信息
	examInfo: {},
	// 缴费信息
	payment: {},
	// 超时信息
	time_out: 0,
	sign_up: null,
};

const getters = {

};

const mutations = {
	// 保存单位名称
	SET_UNIT_NAME(state, unitName) {
		state.unitName = unitName;
	},
	// 保存单位id
	SET_UNIT_ID(state, unitId) {
		state.unitId = unitId;
	},
	// 保存单位网段
	SET_UNIT_CODE(state, unitCode) {
		state.unitCode = unitCode;
	},
	// 保存电脑端判断
	SET_MOBILE(state, mobile) {
		state.mobile = mobile;
	},
	// 保存登录刷新判断
	SET_REFRESH(state, refresh) {
		state.refresh = refresh;
	},
	// 保存单位名称id
	SET_COMPANY_ID(state, company_id) {
		state.company_id = company_id;
	},
	// 保存当前考试信息
	SET_EXAM_INFO(state, data) {
		state.examInfo = data;
	},
	// 保存当前考试缴费信息
	SET_PAY_MENT(state, data) {
		state.payment = data;
	},
	// 保存超时信息
	SET_TIME_OUT(state, time_out) {
		state.time_out = time_out;
	},
	// 保存超时信息
	SET_SIGN_UP(state, sign_up) {
		state.sign_up = sign_up;
	},
};

const actions = {

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
